import React, { Fragment } from 'react';
import cx from 'classnames';
import { ArrowLeftOutlined } from '@ant-design/icons';
import Modal from '../../../../../components/Modal';
import InfoForm from '../../../../../components/outline/InfoForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import InputForm from '../../../../../components/form/InputForm';
import BaseForm from '../../../../../components/form/BaseForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import { byteCount, setNumberWithComma, setPhoneFormat, setDash } from '../../../../../lib/common';
import CountOfTotal from '../../../../../components/CountOfTotal';
import {
  MSG_SERVICE_SEND_TYPE,
  MSG_SERVICE_SEND_MODAL_SECTION_TYPE,
  MSG_SERVICE_SEND_TYPE_SELECT_LIST,
  MSG_SERVICE_SEND_MAXIMUM_BYTE_OF_TEXT,
  MAXIMUM_NUMBER_OF_LMS_SUBJECT_TEXT,
} from '../../../../../constants/service/app/msgServiceSendConstants';
import { AMONDZ_MEMBER_TYPE_TEXT } from '../../../../../constants/service/common/utilConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './SendMessageServiceModal.scss';

const SendMessageServiceModal = (props) => {
  const { isOpen, form, closeModal, sectionType, msgType, subject, content, data, onSubmit, setData, goBack } = props;
  const { memberType, receiverInfo } = data;

  /**
   *  메시지 타입을 선택하는 섹션인 경우
   */
  const isSelectMsgServiceTypeSection =
    sectionType === MSG_SERVICE_SEND_MODAL_SECTION_TYPE.SELECT_MSG_SERVICE_TYPE_SECTION;

  return (
    <Modal
      title="문자 발송하기"
      isOpen={isOpen}
      width={600}
      height={520}
      isFooter={true}
      okText={isSelectMsgServiceTypeSection ? '선택' : '발송하기'}
      onOk={() => {
        /**
         * 메시지 타입을 선택하는 섹션인 경우에는 메시지를 전성하는 폼섹션으로 이동하기
         */
        if (isSelectMsgServiceTypeSection) {
          setData({ name: 'sectionType', value: MSG_SERVICE_SEND_MODAL_SECTION_TYPE.SEND_MSG_SERVICE_FORM_SECTION });
        } else onSubmit();
      }}
      onClose={() => closeModal()}
    >
      <div className="send-message-service-modal">
        {isSelectMsgServiceTypeSection ? (
          /**
           * 메시지 유형을 고르는 섹션
           * msgType :
           *  - 0 : SMS
           *  - 1 : LMS
           */
          <div className="select-message-service-type-section">
            <div className="message-service-type-guid">메시지 유형을 선택해주세요.</div>

            <div className="select-message-service-type">
              {MSG_SERVICE_SEND_TYPE_SELECT_LIST.map((item) => (
                <div
                  key={item.id}
                  className={cx('message-service-type', { active: msgType === item.id })}
                  onClick={() => setData({ name: 'msgType', value: item.id })}
                >
                  {item.name}
                </div>
              ))}
            </div>

            <div className="message-service-type-info">
              {`발신글자 ${setNumberWithComma(
                MSG_SERVICE_SEND_MAXIMUM_BYTE_OF_TEXT[msgType],
              )} Byte 제한(한글 2 Btye, 그 외 1 Btye)`}
            </div>
          </div>
        ) : (
          /**
           * 메시지를 전송하기 위해서 데이터 폼 만들기
           */
          <Fragment>
            <div className="button-section">
              <ArrowLeftOutlined />
              <span onClick={() => goBack()}>뒤로가기</span>
            </div>

            <InfoForm className="send-message-service-form-section">
              {/*메시지를 받는 수신자*/}
              <BaseForm
                label="수신자"
                content={
                  <div>
                    <div>
                      {`${AMONDZ_MEMBER_TYPE_TEXT[memberType]} / ${setDash(receiverInfo.name)} (${
                        receiverInfo.targetId
                      }) / ${setDash(receiverInfo.subInfo)}`}
                    </div>
                    <div>{setPhoneFormat(receiverInfo.cellPhone)}</div>
                  </div>
                }
              />

              {/*제목*/}
              {msgType === MSG_SERVICE_SEND_TYPE.LMS ? (
                <InputForm
                  form={form}
                  label={
                    <span>
                      <span>제목</span>
                      <CountOfTotal content={subject} maxCnt={MAXIMUM_NUMBER_OF_LMS_SUBJECT_TEXT} />
                    </span>
                  }
                  initialValue={subject}
                  maxLength={MAXIMUM_NUMBER_OF_LMS_SUBJECT_TEXT}
                  onChange={(value) => setData({ name: 'subject', value })}
                  rules={[formRequiredRules(true, REQUIRED_MSG)]}
                  name="subject"
                />
              ) : null}

              {/*내용*/}
              <TextAreaForm
                form={form}
                label={
                  <span className="count-of-total">
                    <span>내용</span>
                    <div>
                      <span>({byteCount(content ? content : [])}</span>/{MSG_SERVICE_SEND_MAXIMUM_BYTE_OF_TEXT[msgType]}
                      ) byte
                    </div>
                  </span>
                }
                initialValue={content}
                onChange={(value) => setData({ name: 'content', value })}
                name="content"
                rules={[
                  formRequiredRules(true, REQUIRED_MSG),
                  {
                    validator: (rule, value, cb) => {
                      const maxByte = MSG_SERVICE_SEND_MAXIMUM_BYTE_OF_TEXT[msgType];
                      if (byteCount(value ? value : []) > maxByte) {
                        cb(`${maxByte}byte 를 초과하였습니다.`);
                      } else cb();
                    },
                  },
                ]}
                autoSize={{ minRows: 4, maxRows: 50 }}
              />
            </InfoForm>
          </Fragment>
        )}
      </div>
    </Modal>
  );
};

export default SendMessageServiceModal;
